import { isOverflow, parseAABB } from '../utils/bounds';
import { hide, show } from '../utils/style';
/**
 * Hide the label when the label is overflowed from the element.
 */
export var OverflowHide = function OverflowHide() {
  return function (labels) {
    labels.forEach(function (l) {
      show(l);
      var bounds = l.attr('bounds');
      var b = l.getLocalBounds();
      var overflow = isOverflow(parseAABB(b), bounds);
      if (overflow) hide(l);
    });
    return labels;
  };
};